import React, { useContext, useState, useEffect, useRef } from "react";
import { Navigate, useParams, Link, useNavigate } from "react-router-dom";
import SimulatorHeader from "../../components/simulator-header/SimulatorHeader";
import styles from "./SharePage.styles.scss";
import { UserContext } from "../../App";
import axios from "axios";
import TagManager from "react-gtm-module";
import { toPng } from "html-to-image";

import QRCode from "react-qr-code";

const SharePage = () => {
    const {
        primaryPattern,
        secondaryPattern,
        thirdPattern,
        envVariation,
        setStep,
        setEnvironment,
        setEnvVariation,
        isTotem,
    } = useContext(UserContext);

    const navigate = useNavigate();
    const params = useParams();

    const invertPatterns = () => {
        const shuffleES6 = (array) => {
            array.reverse().forEach((item, index) => {
                const j = Math.floor(Math.random() * (index + 1));
                [array[index], array[j]] = [array[j], array[index]];
            });

            return array;
        };

        let sufflePatterns =
            patternSelectors.length > 2
                ? shuffleES6(patternSelectors)
                : patternSelectors.reverse();

        let url = sufflePatterns
            .map((selector) => {
                return selector.slug;
            })
            .join("|");

        if (url) {
            const totemInfo = isTotem ? "totem_" : "";

            const event = {
                event: "click",
                eventCategory: "click",
                eventAction: totemInfo + "simulador_passo_04_inverter_padrao",
            };

            TagManager.dataLayer({ dataLayer: event });

            navigate(
                `/${params.environment}/${params.enviromentVariation}/${url}`
            );
        }
    };

    const imageContainer = useRef();
    const downloadImage = () => {
        toPng(imageContainer.current, { cacheBust: true, skipFonts: true })
            .then((dataUrl) => {
                const link = document.createElement("a");
                link.download = "ambiente.png";
                link.href = dataUrl;
                link.click();
            })
            .catch((error) => {
                console.error("oops, something went wrong!", error);
            });
    };

    const totalPatterns = params.pattern.split("|").length;

    // console.log("totalPaterns", totalPatterns);
    // console.log("primaryPattern", primaryPattern);
    // console.log("secondaryPattern", secondaryPattern);
    // console.log("thirdPattern", thirdPattern);

    // console.log((totalPatterns == 3) & primaryPattern);
    // console.log((totalPatterns == 2) & primaryPattern);

    const [patternSelectors, setPatternSelectors] = useState(
        totalPatterns == 3 && primaryPattern
            ? [
                {
                    ...primaryPattern.pattern,
                },
                {
                    ...secondaryPattern.pattern,
                },
                {
                    ...thirdPattern.pattern,
                },
            ]
            : totalPatterns == 2 && primaryPattern
                ? [
                    {
                        ...primaryPattern.pattern,
                    },
                    {
                        ...secondaryPattern.pattern,
                    },
                ]
                : []
    );

    // console.log("patternSelectors", patternSelectors);

    useEffect(() => {
        setStep(4);
        if (
            primaryPattern === null &&
            params.environment &&
            params.enviromentVariation &&
            params.pattern
        ) {
            axios
                .get(
                    `${MIX_URL}/simulator-api/${params.environment}/${params.enviromentVariation}/${params.pattern}`
                )
                .then((response) => {
                    setEnvironment(response.data.environment);
                    setEnvVariation(response.data.envVariation);
                    setPatternSelectors(response.data.patterns);
                })
                .catch((err) => {
                    navigate("/escolha-um-ambiente");
                });
        }
    }, []);

    useEffect(() => {
        // Carrega o script do RD Station Forms apenas no client
        if (typeof window !== "undefined" && !document.getElementById("rdstation-forms-script")) {
            const script = document.createElement("script");
            script.id = "rdstation-forms-script";
            script.type = "text/javascript";
            script.src = "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
            script.onload = () => {
                if (window.RDStationForms) {
                    new window.RDStationForms(
                        "am-formulario-simular-ambientes-9bcf744ef961328f049b",
                        "UA-39034747-1"
                    ).createForm();
                }
            };
            document.body.appendChild(script);
        } else if (window.RDStationForms) {
            new window.RDStationForms(
                "am-formulario-simular-ambientes-9bcf744ef961328f049b",
                "UA-39034747-1"
            ).createForm();
        }
    }, []);

    return (
        <div className={`share ${isTotem ? "totem" : ""}`}>
            <div className={`container w-full m-auto`}>
                <SimulatorHeader
                    title="4. Compartilhe a sua criação"
                    prev={`/${params.environment}/${params.enviromentVariation}/selecione-um-padrao`}
                    nextHidden={true}
                />
                <div className="templates grid grid-cols-3 md:grid-cols-3">
                    <div
                        ref={imageContainer}
                        className="image-container col-span-3"
                        style={{}}
                    >
                        <img
                            style={{}}
                            src={`${MIX_AWS_URL}/${envVariation?.image}`}
                        />
                        {patternSelectors.map((selector, index) => (
                            <React.Fragment key={index}>
                                {selector &&
                                    selector.environment_option_patterns !==
                                    null &&
                                    selector?.environment_option_patterns[index]
                                        ?.image && (
                                        <img
                                            style={{}}
                                            src={`${MIX_AWS_URL}/${selector?.environment_option_patterns[index]?.image}`}
                                            className={`overlay_${index}`}
                                        />
                                    )}
                            </React.Fragment>
                        ))}
                    </div>

                    <div className="flex justify-center col-span-3 mt-24 gap-16">
                        <a
                            onClick={() => downloadImage()}
                            className="button button-blue blue-button flex gap-16 cursor-pointer"
                        >
                            <svg
                                fill="#fff"
                                height="16"
                                width="16"
                                viewBox="-3 -3 35.98 35.98"
                            >
                                <g>
                                    <path d="M25.462,19.105v6.848H4.515v-6.848H0.489v8.861c0,1.111,0.9,2.012,2.016,2.012h24.967c1.115,0,2.016-0.9,2.016-2.012 v-8.861H25.462z"></path>
                                    <path d="M14.62,18.426l-5.764-6.965c0,0-0.877-0.828,0.074-0.828s3.248,0,3.248,0s0-0.557,0-1.416c0-2.449,0-6.906,0-8.723 c0,0-0.129-0.494,0.615-0.494c0.75,0,4.035,0,4.572,0c0.536,0,0.524,0.416,0.524,0.416c0,1.762,0,6.373,0,8.742 c0,0.768,0,1.266,0,1.266s1.842,0,2.998,0c1.154,0,0.285,0.867,0.285,0.867s-4.904,6.51-5.588,7.193 C15.092,18.979,14.62,18.426,14.62,18.426z"></path>
                                </g>
                            </svg>
                            <span>Baixar Criação</span>
                        </a>
                        <a
                            onClick={() => invertPatterns()}
                            className="button button-blue blue-button flex gap-16 cursor-pointer"
                        >
                            <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_4390_31305)">
                                    <path
                                        d="M15.3335 3.16699V7.16699H11.3335"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M0.666504 13.833V9.83301H4.6665"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M2.33984 6.50038C2.67795 5.5449 3.25259 4.69064 4.01015 4.01732C4.7677 3.344 5.68348 2.87355 6.67203 2.64988C7.66058 2.42621 8.68967 2.4566 9.6633 2.73823C10.6369 3.01985 11.5233 3.54352 12.2398 4.26038L15.3332 7.16704M0.666504 9.83371L3.75984 12.7404C4.47634 13.4572 5.36275 13.9809 6.33638 14.2625C7.31 14.5441 8.3391 14.5745 9.32765 14.3509C10.3162 14.1272 11.232 13.6568 11.9895 12.9834C12.7471 12.3101 13.3217 11.4559 13.6598 10.5004"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_4390_31305">
                                        <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(0 0.5)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>INVERTER PADRÕES</span>

                            <span className="absolute bottom-[-20px] md:bottom-[13px] md:right-[-66px]">
                                <svg
                                    width="87"
                                    height="32"
                                    viewBox="0 0 87 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        width="87"
                                        height="32"
                                        rx="8"
                                        fill="#FFC700"
                                    />
                                    <g clipPath="url(#clip0_4390_31322)">
                                        <path
                                            d="M14.0004 18.875L10.9144 20.4975L11.5039 17.061L9.00391 14.6275L12.4539 14.1275L13.9969 11.001L15.5399 14.1275L18.9899 14.6275L16.4899 17.061L17.0794 20.4975L14.0004 18.875Z"
                                            fill="#304886"
                                            stroke="#304886"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <path
                                        d="M32.9105 11.4688V20H31.7738L27.4789 13.4199V20H26.348V11.4688H27.4789L31.7914 18.0664V11.4688H32.9105ZM34.8633 16.9004V16.7656C34.8633 16.3086 34.9297 15.8848 35.0625 15.4941C35.1953 15.0996 35.3867 14.7578 35.6367 14.4688C35.8867 14.1758 36.1895 13.9492 36.5449 13.7891C36.9004 13.625 37.2988 13.543 37.7402 13.543C38.1855 13.543 38.5859 13.625 38.9414 13.7891C39.3008 13.9492 39.6055 14.1758 39.8555 14.4688C40.1094 14.7578 40.3027 15.0996 40.4355 15.4941C40.5684 15.8848 40.6348 16.3086 40.6348 16.7656V16.9004C40.6348 17.3574 40.5684 17.7812 40.4355 18.1719C40.3027 18.5625 40.1094 18.9043 39.8555 19.1973C39.6055 19.4863 39.3027 19.7129 38.9473 19.877C38.5957 20.0371 38.1973 20.1172 37.752 20.1172C37.3066 20.1172 36.9062 20.0371 36.5508 19.877C36.1953 19.7129 35.8906 19.4863 35.6367 19.1973C35.3867 18.9043 35.1953 18.5625 35.0625 18.1719C34.9297 17.7812 34.8633 17.3574 34.8633 16.9004ZM35.9473 16.7656V16.9004C35.9473 17.2168 35.9844 17.5156 36.0586 17.7969C36.1328 18.0742 36.2441 18.3203 36.3926 18.5352C36.5449 18.75 36.7344 18.9199 36.9609 19.0449C37.1875 19.166 37.4512 19.2266 37.752 19.2266C38.0488 19.2266 38.3086 19.166 38.5312 19.0449C38.7578 18.9199 38.9453 18.75 39.0938 18.5352C39.2422 18.3203 39.3535 18.0742 39.4277 17.7969C39.5059 17.5156 39.5449 17.2168 39.5449 16.9004V16.7656C39.5449 16.4531 39.5059 16.1582 39.4277 15.8809C39.3535 15.5996 39.2402 15.3516 39.0879 15.1367C38.9395 14.918 38.752 14.7461 38.5254 14.6211C38.3027 14.4961 38.041 14.4336 37.7402 14.4336C37.4434 14.4336 37.1816 14.4961 36.9551 14.6211C36.7324 14.7461 36.5449 14.918 36.3926 15.1367C36.2441 15.3516 36.1328 15.5996 36.0586 15.8809C35.9844 16.1582 35.9473 16.4531 35.9473 16.7656ZM44.2281 19.0215L45.9625 13.6602H47.0699L44.7906 20H44.0641L44.2281 19.0215ZM42.7809 13.6602L44.568 19.0508L44.691 20H43.9645L41.6676 13.6602H42.7809ZM49.6906 13.6602V20H48.6008V13.6602H49.6906ZM48.5188 11.9785C48.5188 11.8027 48.5715 11.6543 48.677 11.5332C48.7863 11.4121 48.9465 11.3516 49.1574 11.3516C49.3645 11.3516 49.5227 11.4121 49.632 11.5332C49.7453 11.6543 49.802 11.8027 49.802 11.9785C49.802 12.1465 49.7453 12.291 49.632 12.4121C49.5227 12.5293 49.3645 12.5879 49.1574 12.5879C48.9465 12.5879 48.7863 12.5293 48.677 12.4121C48.5715 12.291 48.5188 12.1465 48.5188 11.9785ZM55.827 18.7695V11H56.9168V20H55.9207L55.827 18.7695ZM51.5613 16.9004V16.7773C51.5613 16.293 51.6199 15.8535 51.7371 15.459C51.8582 15.0605 52.0281 14.7188 52.2469 14.4336C52.4695 14.1484 52.7332 13.9297 53.0379 13.7773C53.3465 13.6211 53.6902 13.543 54.0691 13.543C54.4676 13.543 54.8152 13.6133 55.1121 13.7539C55.4129 13.8906 55.6668 14.0918 55.8738 14.3574C56.0848 14.6191 56.2508 14.9355 56.3719 15.3066C56.493 15.6777 56.577 16.0977 56.6238 16.5664V17.1055C56.5809 17.5703 56.4969 17.9883 56.3719 18.3594C56.2508 18.7305 56.0848 19.0469 55.8738 19.3086C55.6668 19.5703 55.4129 19.7715 55.1121 19.9121C54.8113 20.0488 54.4598 20.1172 54.0574 20.1172C53.6863 20.1172 53.3465 20.0371 53.0379 19.877C52.7332 19.7168 52.4695 19.4922 52.2469 19.2031C52.0281 18.9141 51.8582 18.5742 51.7371 18.1836C51.6199 17.7891 51.5613 17.3613 51.5613 16.9004ZM52.6512 16.7773V16.9004C52.6512 17.2168 52.6824 17.5137 52.7449 17.791C52.8113 18.0684 52.9129 18.3125 53.0496 18.5234C53.1863 18.7344 53.3602 18.9004 53.5711 19.0215C53.782 19.1387 54.034 19.1973 54.327 19.1973C54.6863 19.1973 54.9813 19.1211 55.2117 18.9688C55.4461 18.8164 55.6336 18.6152 55.7742 18.3652C55.9148 18.1152 56.0242 17.8438 56.1023 17.5508V16.1387C56.0555 15.9238 55.9871 15.7168 55.8973 15.5176C55.8113 15.3145 55.698 15.1348 55.5574 14.9785C55.4207 14.8184 55.2508 14.6914 55.0477 14.5977C54.8484 14.5039 54.6121 14.457 54.3387 14.457C54.0418 14.457 53.7859 14.5195 53.5711 14.6445C53.3602 14.7656 53.1863 14.9336 53.0496 15.1484C52.9129 15.3594 52.8113 15.6055 52.7449 15.8867C52.6824 16.1641 52.6512 16.4609 52.6512 16.7773ZM62.7426 18.916V15.6523C62.7426 15.4023 62.6918 15.1855 62.5902 15.002C62.4926 14.8145 62.3441 14.6699 62.1449 14.5684C61.9457 14.4668 61.6996 14.416 61.4066 14.416C61.1332 14.416 60.893 14.4629 60.6859 14.5566C60.4828 14.6504 60.3227 14.7734 60.2055 14.9258C60.0922 15.0781 60.0355 15.2422 60.0355 15.418H58.9516C58.9516 15.1914 59.0102 14.9668 59.1273 14.7441C59.2445 14.5215 59.4125 14.3203 59.6312 14.1406C59.8539 13.957 60.1195 13.8125 60.4281 13.707C60.7406 13.5977 61.0883 13.543 61.4711 13.543C61.932 13.543 62.3383 13.6211 62.6898 13.7773C63.0453 13.9336 63.3227 14.1699 63.5219 14.4863C63.725 14.7988 63.8266 15.1914 63.8266 15.6641V18.6172C63.8266 18.8281 63.8441 19.0527 63.8793 19.291C63.9184 19.5293 63.975 19.7344 64.0492 19.9062V20H62.9184C62.8637 19.875 62.8207 19.709 62.7895 19.502C62.7582 19.291 62.7426 19.0957 62.7426 18.916ZM62.9301 16.1562L62.9418 16.918H61.8461C61.5375 16.918 61.2621 16.9434 61.0199 16.9941C60.7777 17.041 60.5746 17.1133 60.4105 17.2109C60.2465 17.3086 60.1215 17.4316 60.0355 17.5801C59.9496 17.7246 59.9066 17.8945 59.9066 18.0898C59.9066 18.2891 59.9516 18.4707 60.0414 18.6348C60.1312 18.7988 60.266 18.9297 60.4457 19.0273C60.6293 19.1211 60.8539 19.168 61.1195 19.168C61.4516 19.168 61.7445 19.0977 61.9984 18.957C62.2523 18.8164 62.4535 18.6445 62.602 18.4414C62.7543 18.2383 62.8363 18.041 62.848 17.8496L63.3109 18.3711C63.2836 18.5352 63.2094 18.7168 63.0883 18.916C62.9672 19.1152 62.8051 19.3066 62.602 19.4902C62.4027 19.6699 62.1645 19.8203 61.8871 19.9414C61.6137 20.0586 61.3051 20.1172 60.9613 20.1172C60.5316 20.1172 60.1547 20.0332 59.8305 19.8652C59.5102 19.6973 59.2602 19.4727 59.0805 19.1914C58.9047 18.9062 58.8168 18.5879 58.8168 18.2363C58.8168 17.8965 58.8832 17.5977 59.016 17.3398C59.1488 17.0781 59.3402 16.8613 59.5902 16.6895C59.8402 16.5137 60.141 16.3809 60.4926 16.291C60.8441 16.2012 61.2367 16.1562 61.6703 16.1562H62.9301ZM69.9277 18.7695V11H71.0176V20H70.0215L69.9277 18.7695ZM65.6621 16.9004V16.7773C65.6621 16.293 65.7207 15.8535 65.8379 15.459C65.959 15.0605 66.1289 14.7188 66.3477 14.4336C66.5703 14.1484 66.834 13.9297 67.1387 13.7773C67.4473 13.6211 67.791 13.543 68.1699 13.543C68.5684 13.543 68.916 13.6133 69.2129 13.7539C69.5137 13.8906 69.7676 14.0918 69.9746 14.3574C70.1855 14.6191 70.3516 14.9355 70.4727 15.3066C70.5938 15.6777 70.6777 16.0977 70.7246 16.5664V17.1055C70.6816 17.5703 70.5977 17.9883 70.4727 18.3594C70.3516 18.7305 70.1855 19.0469 69.9746 19.3086C69.7676 19.5703 69.5137 19.7715 69.2129 19.9121C68.9121 20.0488 68.5605 20.1172 68.1582 20.1172C67.7871 20.1172 67.4473 20.0371 67.1387 19.877C66.834 19.7168 66.5703 19.4922 66.3477 19.2031C66.1289 18.9141 65.959 18.5742 65.8379 18.1836C65.7207 17.7891 65.6621 17.3613 65.6621 16.9004ZM66.752 16.7773V16.9004C66.752 17.2168 66.7832 17.5137 66.8457 17.791C66.9121 18.0684 67.0137 18.3125 67.1504 18.5234C67.2871 18.7344 67.4609 18.9004 67.6719 19.0215C67.8828 19.1387 68.1348 19.1973 68.4277 19.1973C68.7871 19.1973 69.082 19.1211 69.3125 18.9688C69.5469 18.8164 69.7344 18.6152 69.875 18.3652C70.0156 18.1152 70.125 17.8438 70.2031 17.5508V16.1387C70.1562 15.9238 70.0879 15.7168 69.998 15.5176C69.9121 15.3145 69.7988 15.1348 69.6582 14.9785C69.5215 14.8184 69.3516 14.6914 69.1484 14.5977C68.9492 14.5039 68.7129 14.457 68.4395 14.457C68.1426 14.457 67.8867 14.5195 67.6719 14.6445C67.4609 14.7656 67.2871 14.9336 67.1504 15.1484C67.0137 15.3594 66.9121 15.6055 66.8457 15.8867C66.7832 16.1641 66.752 16.4609 66.752 16.7773ZM75.7359 20.1172C75.2945 20.1172 74.8941 20.043 74.5348 19.8945C74.1793 19.7422 73.8727 19.5293 73.6148 19.2559C73.3609 18.9824 73.1656 18.6582 73.0289 18.2832C72.8922 17.9082 72.8238 17.498 72.8238 17.0527V16.8066C72.8238 16.291 72.9 15.832 73.0523 15.4297C73.2047 15.0234 73.4117 14.6797 73.6734 14.3984C73.9352 14.1172 74.232 13.9043 74.5641 13.7598C74.8961 13.6152 75.2398 13.543 75.5953 13.543C76.0484 13.543 76.4391 13.6211 76.7672 13.7773C77.0992 13.9336 77.3707 14.1523 77.5816 14.4336C77.7926 14.7109 77.9488 15.0391 78.0504 15.418C78.152 15.793 78.2027 16.2031 78.2027 16.6484V17.1348H73.4684V16.25H77.1188V16.168C77.1031 15.8867 77.0445 15.6133 76.943 15.3477C76.8453 15.082 76.6891 14.8633 76.4742 14.6914C76.2594 14.5195 75.9664 14.4336 75.5953 14.4336C75.3492 14.4336 75.1227 14.4863 74.9156 14.5918C74.7086 14.6934 74.5309 14.8457 74.3824 15.0488C74.234 15.252 74.1188 15.5 74.0367 15.793C73.9547 16.0859 73.9137 16.4238 73.9137 16.8066V17.0527C73.9137 17.3535 73.9547 17.6367 74.0367 17.9023C74.1227 18.1641 74.2457 18.3945 74.4059 18.5938C74.5699 18.793 74.7672 18.9492 74.9977 19.0625C75.232 19.1758 75.4977 19.2324 75.7945 19.2324C76.1773 19.2324 76.5016 19.1543 76.7672 18.998C77.0328 18.8418 77.2652 18.6328 77.4645 18.3711L78.1207 18.8926C77.984 19.0996 77.8102 19.2969 77.5992 19.4844C77.3883 19.6719 77.1285 19.8242 76.8199 19.9414C76.5152 20.0586 76.1539 20.1172 75.7359 20.1172Z"
                                        fill="#304886"
                                    />
                                    <defs>
                                        <clipPath id="clip0_4390_31322">
                                            <rect
                                                width="12"
                                                height="12"
                                                fill="white"
                                                transform="translate(8 10)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </a>
                    </div>

                    <div className="select-patterns col-span-3">
                        <h2>PADRÕES ESCOLHIDOS</h2>
                        <div className="pattern-list flex justify-between flex-row">
                            <div className="flex-1">
                                {patternSelectors.map((selector, index) => (
                                    <div key={index} className="pattern-item">
                                        {selector &&
                                            selector?.pattern !== null && (
                                                <>
                                                    <div className="content-wrapper">
                                                        <div className="relative">
                                                            <img
                                                                src={`${MIX_AWS_URL}/${selector.thumb_image}`}
                                                                className={`overlay_${index}`}
                                                            />

                                                            <div className="absolute top-5">
                                                                {selector.ultra_premium ==
                                                                    1 && (
                                                                        <div className="relative">
                                                                            <div className="relative z-10 flex mb-5 gap-5 p-5 bg-white left-0 text-8 text-lightblue">
                                                                                <svg
                                                                                    width="6"
                                                                                    height="9"
                                                                                    viewBox="0 0 10 14"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M1.53467 6.64812C1.18407 7.29213 0.999676 8.0225 1 8.76587C1.00032 9.50923 1.18536 10.2394 1.53651 10.8831C1.88767 11.5267 2.39258 12.0612 3.00053 12.4328C3.60848 12.8044 4.29806 13 5 13C5.70194 13 6.39152 12.8044 6.99947 12.4328C7.60742 12.0612 8.11233 11.5267 8.46349 10.8831C8.81464 10.2394 8.99968 9.50923 9 8.76587C9.00032 8.0225 8.81593 7.29213 8.46533 6.64812L5.00067 1L1.53467 6.64812Z"
                                                                                        stroke="#3658B3"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                </svg>
                                                                                ULTRA
                                                                                PREMIUM
                                                                            </div>

                                                                            <span className="skew"></span>
                                                                        </div>
                                                                    )}

                                                                {selector.fire ==
                                                                    1 && (
                                                                        <div className="relative inline-flex">
                                                                            <div className="relative flex z-10 justify-start p-5 gap-5 bg-white left-0 text-8 text-red">
                                                                                <svg
                                                                                    width="6"
                                                                                    height="9"
                                                                                    viewBox="0 0 10 14"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5 6.64706C6.33333 4.55765 5 1.70588 4.33333 1C4.33333 3.14447 3.15133 4.34659 2.33333 5.23529C1.516 6.12471 1 7.52235 1 8.76471C1 9.88798 1.42143 10.9652 2.17157 11.7595C2.92172 12.5538 3.93913 13 5 13C6.06087 13 7.07828 12.5538 7.82843 11.7595C8.57857 10.9652 9 9.88798 9 8.76471C9 7.68329 8.296 5.98353 7.66667 5.23529C6.476 7.35294 5.806 7.35294 5 6.64706Z"
                                                                                        stroke="#EA3D2F"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                </svg>
                                                                                FIRE
                                                                            </div>

                                                                            <span className="skew"></span>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                        <div className="patternInfo">
                                                            <h5>
                                                                {selector.name}
                                                            </h5>
                                                            <span>
                                                                {
                                                                    selector.family
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {!isTotem && (
                                                        <a
                                                            href={selector.link}
                                                            target="_blank"
                                                            className="more-buttom text-grayBase"
                                                            onClick={() => {
                                                                const totemInfo = isTotem
                                                                    ? "totem_"
                                                                    : "";
                                                                const event = {
                                                                    event:
                                                                        "click",
                                                                    eventCategory:
                                                                        "click",
                                                                    eventAction:
                                                                        totemInfo +
                                                                        "simulador_passo_04_click_saiba_mais",
                                                                };

                                                                TagManager.dataLayer(
                                                                    {
                                                                        dataLayer: event,
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            SAIBA MAIS
                                                            <span className="material-icons block ml-10">
                                                                arrow_forward
                                                            </span>
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                    </div>
                                ))}
                            </div>

                            {isTotem && (
                                <div className="border border-gray40 p-20 w-300">
                                    <p className="text-24 text-lightblue font-light">
                                        Gostou do resultado?
                                    </p>

                                    <p className="flex flex-col gap-10 text-20 leading-6 text-grayBase font-light">
                                        Escaneie o QR code ao lado e salve o
                                        ambiente gerado para futuras consultas
                                        <QRCode
                                            className="m-auto"
                                            size={130}
                                            value={window.location.href.replace(
                                                "totem/",
                                                ""
                                            )}
                                        />
                                    </p>
                                </div>
                            )}
                        </div>

                        {!isTotem && (
                            <div className="ctas">
                                <Link
                                    to="/"
                                    className="button blue-button-border"
                                >
                                    MONTAR OUTRO AMBIENTE
                                </Link>

                                <a
                                    target="_blank"
                                    onClick={() => {
                                        const totemInfo = isTotem
                                            ? "totem_"
                                            : "";
                                        const event = {
                                            event: "click",
                                            eventCategory: "click",
                                            eventAction:
                                                totemInfo +
                                                "simulador_passo_04_click_compartilhar",
                                        };

                                        TagManager.dataLayer({
                                            dataLayer: event,
                                        });
                                    }}
                                    href={`https://api.whatsapp.com/send?text=Veja só esse ambiente com a combinação de padrões Duratex que acabei de criar: ${window.location.href}`}
                                    className="button button-blue blue-button"
                                >
                                    <span>COMPARTILHAR</span>
                                    <svg
                                        width="17"
                                        height="16"
                                        viewBox="0 0 17 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13.3811 3.04324C12.0946 1.71892 10.3162 1 8.5 1C4.64054 1 1.53784 4.14054 1.57568 7.96216C1.57568 9.17297 1.91622 10.3459 2.48378 11.4054L1.5 15L5.17027 14.0541C6.19189 14.6216 7.32703 14.8865 8.46216 14.8865C12.2838 14.8865 15.3865 11.7459 15.3865 7.92432C15.3865 6.07027 14.6676 4.32973 13.3811 3.04324ZM8.5 13.7135C7.47838 13.7135 6.45676 13.4486 5.58649 12.9189L5.35946 12.8054L3.16487 13.373L3.73243 11.2162L3.58108 10.9892C1.91622 8.3027 2.71081 4.74595 5.43514 3.08108C8.15946 1.41622 11.6784 2.21081 13.3432 4.93514C15.0081 7.65946 14.2135 11.1784 11.4892 12.8432C10.6189 13.4108 9.55946 13.7135 8.5 13.7135ZM11.8297 9.51351L11.4135 9.32432C11.4135 9.32432 10.8081 9.05946 10.4297 8.87027C10.3919 8.87027 10.3541 8.83243 10.3162 8.83243C10.2027 8.83243 10.127 8.87027 10.0514 8.90811C10.0514 8.90811 10.0135 8.94595 9.48378 9.55135C9.44595 9.62703 9.37027 9.66486 9.2946 9.66486H9.25676C9.21892 9.66486 9.14324 9.62703 9.10541 9.58919L8.91622 9.51351C8.5 9.32432 8.12162 9.0973 7.81892 8.7946C7.74324 8.71892 7.62973 8.64324 7.55405 8.56757C7.28919 8.3027 7.02432 8 6.83514 7.65946L6.7973 7.58378C6.75946 7.54595 6.75946 7.50811 6.72162 7.43243C6.72162 7.35676 6.72162 7.28108 6.75946 7.24324C6.75946 7.24324 6.91081 7.05405 7.02432 6.94054C7.1 6.86487 7.13784 6.75135 7.21351 6.67568C7.28919 6.56216 7.32703 6.41081 7.28919 6.2973C7.25135 6.10811 6.7973 5.08649 6.68378 4.85946C6.60811 4.74595 6.53243 4.70811 6.41892 4.67027H6.30541C6.22973 4.67027 6.11622 4.67027 6.0027 4.67027C5.92703 4.67027 5.85135 4.70811 5.77568 4.70811L5.73784 4.74595C5.66216 4.78378 5.58649 4.85946 5.51081 4.8973C5.43514 4.97297 5.3973 5.04865 5.32162 5.12432C5.05676 5.46486 4.90541 5.88108 4.90541 6.2973C4.90541 6.6 4.98108 6.9027 5.09459 7.16757L5.13243 7.28108C5.47297 8 5.92703 8.64324 6.53243 9.21081L6.68378 9.36216C6.7973 9.47568 6.91081 9.55135 6.98649 9.66486C7.78108 10.3459 8.68919 10.8378 9.71081 11.1027C9.82433 11.1405 9.97568 11.1405 10.0892 11.1784C10.2027 11.1784 10.3541 11.1784 10.4676 11.1784C10.6568 11.1784 10.8838 11.1027 11.0351 11.027C11.1487 10.9514 11.2243 10.9514 11.3 10.8757L11.3757 10.8C11.4514 10.7243 11.527 10.6865 11.6027 10.6108C11.6784 10.5351 11.7541 10.4595 11.7919 10.3838C11.8676 10.2324 11.9054 10.0432 11.9432 9.85405C11.9432 9.77838 11.9432 9.66487 11.9432 9.58919C11.9432 9.58919 11.9054 9.55135 11.8297 9.51351Z"
                                            fill="white"
                                        />
                                    </svg>
                                </a>
                            </div>
                        )}
                        {isTotem && (
                            <div className="ctas">
                                <Link
                                    to="/"
                                    className="button blue-button-border"
                                >
                                    MONTAR OUTRO AMBIENTE
                                </Link>

                                <a
                                    target="_blank"
                                    onClick={() => {
                                        window.location.href =
                                            MIX_URL + "/totem";
                                    }}
                                    className="button button-blue blue-button"
                                >
                                    <span>FINALIZAR</span>
                                </a>
                            </div>
                        )}
                    <div className="mx-auto">
                        <div role="main" id="am-formulario-simular-ambientes-9bcf744ef961328f049b"></div>
                    </div>
                    </div>
                </div>
            </div>
            {!isTotem && (
                <div className="hidden md:flex justify-between border border-gray40 m-auto mb-56 p-35 w-[1100px]">
                    <div>
                        <p className="text-24 text-lightblue font-light">
                            Conheça nossa composição Fire e Ultra Premium
                        </p>
                        <p className="text-20 text-grayBase font-light">
                            Os mesmos padrões de qualidade com resistência à
                            fogo e água
                        </p>
                    </div>

                    <Link
                        to="https://www.duratexmadeira.com.br/produtos/?filtro_composicoes%5B%5D=111808&filtro_composicoes%5B%5D=111807"
                        className="button blue-button-border"
                        target="_blank"
                    >
                        SAIBA MAIS
                    </Link>
                </div>
            )}
        </div>
    );
};

export default SharePage;
